import store from '../reducers/storeRegistration';
import behaviorCacheUtils from '../utils/behaviorCacheUtils';

/**
 * Module-level variable to store config behaviors
 */
let configBehaviors = {};

/**
 * t Return a function that will return the configBehaviors
 */
const configBehaviorsFunc = () => {
  if (Object.keys(configBehaviors).length > 0) {
    return configBehaviors;
  }
  behaviorCacheUtils.clearAllBehaviorCaches();
  const _store$getState = store.getState(),
    configBehavior = _store$getState.configBehavior;
  const _configBehavior$list = configBehavior.list,
    list = _configBehavior$list === void 0 ? [] : _configBehavior$list;
  list.forEach(behavior => {
    configBehaviors[behavior.identifier] = behavior.code;
  });
  return configBehaviors;
};

/**
 * Clear the behavior cache and reset the configBehaviors object
 */
const clearConfigBehaviors = () => {
  // We don't call clearAllBehaviorCaches here to avoid circular calls
  configBehaviors = {};
};

// Register our clear function with the utility
behaviorCacheUtils.registerClearConfigBehaviors(clearConfigBehaviors);
export { configBehaviorsFunc, clearConfigBehaviors };